module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "df-password"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertVisible),
      expression: "alertVisible"
    }],
    staticClass: "alert",
    attrs: {
      "title": "旅行者，密码重置邮件成功。请前往注册邮箱查收，些许邮箱在垃圾邮件才能找到，:)",
      "type": "success"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("旅行者，寻回你的密纹")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "form c-form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入你的注册邮箱"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "publish btn-pub",
    attrs: {
      "disabled": _vm.isLoaded,
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("发送邮件")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca92727","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/password/Forget.vue
// module id = 757
// module chunks = 2